import { render, staticRenderFns } from "./CreatePostNew.vue?vue&type=template&id=64449e13&scoped=true&"
import script from "./CreatePostNew.vue?vue&type=script&lang=js&"
export * from "./CreatePostNew.vue?vue&type=script&lang=js&"
import style0 from "./CreatePostNew.vue?vue&type=style&index=0&id=64449e13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64449e13",
  null
  
)

export default component.exports